export const core = {
  elizabeth: '#009623',
  'queen-elizabeth': '#009623',
  kate: '#ffb400',
  'princess-kate': '#ffb400',
  white: '#ffffff',
  doc: '#444444'
};

export const lights = {
  sneezy: '#eeeeee',
  sleepy: '#dddddd',
  happy: '#cccccc'
};

export const darks = {
  grumpy: '#888888',
  dopey: '#666666',
  bashful: '#222222'
};

export const highlights = {
  harry: '#26b11b',
  'prince-harry': '#26b11b',
  malcolm: '#00abcc',
  malcom: '#00abcc',
  peter: '#7e3e97',
  julia: '#e74c3c'
};

export const functional = {
  kevin: '#94040c'
};

export const greens = {
  william: '#008a20',
  'prince-william': '#008a20',
  charles: '#0a6d12',
  'prince-charles': '#0a6d12',
  philip: '#005b11',
  'prince-philip': '#005b11'
};

export const blues = {
  tony: '#0067b6',
  john: '#18659f',
  harold: '#005487'
};

export const purples = {
  quentin: '#68367f',
  ninian: '#602f73',
  zelman: '#552c68'
};

export const hospitalTiers = {
  basic: '#144a38',
  bronze: '#cd7f32',
  silver: '#83aebe',
  gold: '#c5b358'
};

export const theCheckUp = {
  active: '#dde224',
  future: '#3d5afe',
  health: '#ff5722',
  community: '#1de9b6'
};

export const foundation = {
  ...core,
  ...lights,
  ...darks,
  ...highlights,
  ...functional
};

export const product = {
  ...greens,
  ...blues,
  ...purples,
  ...hospitalTiers
};

const colors = {
  ...foundation,
  ...product,
  ...theCheckUp
};

export default colors;
